import { TokenResponse } from "../contexts/CourtAuthContext";
import persistentStorage from "./persistent-storage";

let inmemoryTokenResponse: string | null = null;

function decode() {
  const base64 = inmemoryTokenResponse || persistentStorage.getItem("tokenResponse") || "bnVsbA==";
  return window.atob(base64);
}

function encode(token: TokenResponse) {
  const text = JSON.stringify(token);
  return window.btoa(text);
}

function draft(token: TokenResponse) {
  // 이전 세션의 영속 토큰을 남겨두면 읽을 때 잘못 읽게 되므로 삭제
  persistentStorage.removeItem("tokenResponse");
  inmemoryTokenResponse = encode(token);
}

// 약관 통과 전(localStorage 미존재)엔 메모리에만, 통과 후엔 영속 갱신
function persistOrDraft(token: TokenResponse) {
  if (persistentStorage.getItem("tokenResponse")) {
    save(token);
  } else {
    draft(token);
  }
}

function save(token: TokenResponse) {
  const base64 = encode(token);
  persistentStorage.setItem("tokenResponse", base64);
  inmemoryTokenResponse = null;
}

function commit() {
  if (!inmemoryTokenResponse) {
    return
  }

  persistentStorage.setItem("tokenResponse", inmemoryTokenResponse);
  inmemoryTokenResponse = null;
}

function load() {
  const text = decode();
  if (text === "null") {
    return null;
  } else {
    return JSON.parse(text) as TokenResponse;
  }
}

function remove() {
  persistentStorage.removeItem("tokenResponse");
  inmemoryTokenResponse = null;
}

const tokenResponseRepository = { save, load, remove, draft, commit, persistOrDraft };

export default tokenResponseRepository;
